module.exports = __webpack_public_path__ + "static/pie-chart-ecfa3971f7dfa74fb80b0e9fbfd240b0.png";